const getExtraGraphics = () => ({
  logo: null,
  favIcon: null,
  colors: {},
  classNames: ''
});

export default getExtraGraphics;
